<div class="notifications" *ngIf="isOpen">

	<div class="notifications-inner">

		<div class="notifications-header">
			<h3 tt>Notifications</h3>
			<div class="notifications-header-actions">
				<button class="notifications-mark-all-read"
				        *ngIf="hasUnreadNotifications"
				        (click)="markAllAsRead()"
				        tt>
					Mark all as read
				</button>
				<span class="notifications-close" (click)="close()">
					<i class="pi pi-times-circle"></i>
				</span>
			</div>
		</div>

		<div class="notifications-list">
			<div *ngIf="notifications.length === 0" class="notifications-empty">
				<div class="notifications-empty--icon">
					<i class="pi pi-bell"></i>
				</div>
				<p class="notifications-empty--message" tt>No notifications at the moment</p>
			</div>

			<div *ngFor="let notification of notifications" class="notifications-list--item"
			     [ngClass]="{ 'unread': !notification.read_at }">
				<div class="notifications-item notification-{{notification.type}}"
				     [class.has-content]="notification?.html"
				     (click)="openContent(notification)">
					<div class="notifications-item--icon">
						<i [class]="getIcon(notification.type)"></i>
					</div>
					<div class="notifications-item--content">
						<div class="notifications-item--header">
							<h5 class="notifications-item--title">{{ notification.title }}</h5>
							<span
								class="notifications-item--timestamp">
								<span class="unread-indicator" *ngIf="!notification.read_at"></span>
								<i class="pi pi-check read-indicator" *ngIf="notification.read_at"></i>
								{{ formatTimeAgo(notification.created_date) }}
							</span>
						</div>
						<div class="notifications-item--excerpt" *ngIf="!notification?.expanded">
							{{ notification.excerpt }}
						</div>
						<div class="notifications-item--inner_content"
						     *ngIf="notification?.html && notification?.expanded"
						     [innerHTML]="notification.html | safeHtml">
						</div>
					</div>
				</div>
			</div>
			<div class="notifications-list--item-placeholder"></div>
		</div>

	</div>

	<div class="notifications-overlay" (click)="close()"></div>

</div>
